export const colorPallet0 = [
  '#00A1D5',
  '#F39B7F',
  '#BA6338',
  '#8491B4',
  '#3C5488',
  '#7A65A5',
  '#80796B',
  '#6A6599',
  '#DC0000',
  '#837B8D',
  '#E7C76F',
  '#DF8F44',
  '#CDDEB7',
  '#E64B35',
  '#91D1C2',
  '#924822',
  '#B09C85',
  '#F0E685',
  '#4DBBD5',
  '#AE1F63',
  '#7E6148',
  '#612A79',
  '#5050FF',
  '#D595A7',
  '#466983',
  '#3B1B53',
  '#749B58',
  '#802268',
  '#5DB1DD',
  '#E4AF69',
  '#79AF97',
  '#00A087',
  '#374E55',
  '#B24745',
  '#C75127',
  '#CE3D32',
  '#6BD76B',
  '#D58F5C',
];

export const mutationalPatternColors = [
  '#499855',
  '#E1A7AB',
  '#40004B',
  '#5AA1CA',
  '#305D38',
  '#775940',
  '#6E70B7',
  '#FF7E00',
  '#FEC34E',
  '#846A2A',
  '#CAB3D5',
  '#F3A582',
  '#8ED3C7',
  '#5E50A2',
  '#761429',
  '#FFED6F',
  '#E31A1B',
  '#FFFFBF',
  '#4D4D4D',
  '#513176',
  '#DE4D7D',
  '#0B519C',
  '#B3DE68',
  '#DEC27D',
  '#B1172B',
  '#03655E',
  '#9ECAE0',
  '#1D9099',
  '#35978F',
  '#EB7012',
  '#b2182b',
  '#9ecae1',
  '#01665e',
  '#d53e4f',
  '#1c9099',
  '#35978f',
  '#ec7014',
  '#f46d43',
  '#de77ae',
  '#fdae61',
  '#d9d9d9',
  '#f781bf',
  '#dd1c77',
  '#b25d7e',
  '#fee08b',
  '#fc8d59',
  'yellow',
  '#e6f598',
  '#abdda4',
  '#636363',
  '#b15928',
];

export const colorPallet1 = [
  '#1F77B4',
  '#FF7F0F',
  '#2DA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
];

const originalColorPallet = {
  1: '#4a9855',
  2: '#e2a8ab',
  3: '#40004b',
  4: '#5aa1ca',
  5: '#305d39',
  6: '#785940',
  7: '#65949d',
  8: '#cab2d6',
  9: '#f4a582',
  10: '#65da51',
  11: '#9e0142',
  12: '#ffed6f',
  13: '#e41a1c',
  14: '#ffffbf',
  15: '#4d4d4d',
  16: '#513276',
  17: '#ef4c7d',
  18: '#b3de69',
  19: '#dfc27d',
  20: '#b2182b',
  21: '#9ecae1',
  22: '#01665e',
  23: '#d53e4f',
  24: '#1c9099',
  25: '#35978f',
  26: '#ec7014',
  27: '#f46d43',
  28: '#de77ae',
  29: '#fdae61',
  30: '#d9d9d9',
  31: '#f781bf',
  32: '#dd1c77',
  33: '#b25d7e',
  34: '#fee08b',
  35: '#fc8d59',
  36: 'yellow',
  37: '#e6f598',
  38: '#abdda4',
  39: '#636363',
  40: '#b15928',
  41: '#fccde5',
  42: '#ae017e',
  43: '#66c2a5',
  44: '#8c6bb1',
  45: '#3288bd',
  46: '#e6f598',
  47: '#bababa',
  48: '#5e4fa2',
  49: '#40004b',
  50: '#762a83',
  51: '#9970ab',
  52: '#c2a5cf',
  53: '#e7d4e8',
  54: '#fcc5c0',
  55: '#d9f0d3',
  56: '#8c510a',
  57: '#a6dba0',
  58: '#5aae61',
  59: '#1b7837',
  60: '#00441b',
  61: '#ffcb25',
  62: '#4e6c83',
  63: '#bda084',
  64: '#d7445d',
  65: '#5b1061',
  66: '#159701',
  67: '#8d6586',
  68: '#bc0a52',
  69: '#6d30c3',
  70: '#6e4f67',
  71: '#755e0f',
  72: '#771e1f',
  73: '#dbe7d2',
  74: '#d138e5',
  75: '#f11ca',
  76: '#8dc37c',
  77: '#578ae8',
  78: '#f99a20',
  79: '#26dddb',
  80: '#f39fd2',
  81: '#9cec5f',
  82: '#553cf1',
  83: '#846864',
  84: '#063C3C',
  85: '#AA9139',
  86: '#a72b74',
  87: '#68f07c',
  88: '#BB9139',
  89: '#8cef1',
  90: '#76b887',
  91: '#ca286e',
  92: '#0E1844',
  93: '#712fde',
  94: '#ee9472',
  95: '#a7429c',
  96: '#1F77B5',
  97: '#58b6f6',
  98: '#f0f56e',
  99: '#678ed9',
  100: '#ccdaca',
  101: '#92994e',
  102: '#78c482',
  103: '#a31a6c',
  104: '#4340ea',
  105: '#c9ce33',
  106: '#e4b2b1',
  107: '#af4df0',
  108: '#7c50f8',
  109: '#e0a301',
  110: '#5E1855',
  '7a': '#6e70b7',
  '7b': '#ff7f00',
  '7c': '#fec44f',
  '7d': '#846a2a',
  '10a': '#8dd3c7',
  '10b': '#5e4fa2',
  '10c': '#761429',
  '17a': '#df4c7d',
  '17b': '#08519c',
  '96A': '#2C77B5',
  '96B': '#DFC8A5',
  '96C': '#4F27B5',
  '96D': '#1FBBB5',
  '-others': '#cececa',
  '1a': '#38cf51',
  '1A': '#5b75ac',
  '1b': '#3ffd52',
  '1B': '#c2942c',
  '1c': '#448ca7',
  '1C': '#6503d3',
  '1d': '#3a7177',
  '1D': '#61b13c',
  '2a': '#32c246',
  '2A': '#4d8209',
  '2b': '#c69612',
  '2B': '#fa4819',
  '2c': '#7f3102',
  '2C': '#a6e097',
  '2d': '#8b9772',
  '2D': '#7ccbca',
  '3a': '#6c8ea4',
  '3A': '#106d47',
  '3b': '#8b26e3',
  '3B': '#d9d3f',
  '3c': '#dfac35',
  '3C': '#cfbf79',
  '3d': '#577334',
  '3D': '#28323f',
  '4a': '#d3ecae',
  '4A': '#c70ae5',
  '4b': '#c34816',
  '4B': '#dd149e',
  '4c': '#a5882c',
  '4C': '#b9baa4',
  '4d': '#d5f2e2',
  '4D': '#d9ded9',
  '5a': '#1f5d4c',
  '5A': '#ce7985',
  '5b': '#f7fa19',
  '5B': '#459160',
  '5c': '#2ef333',
  '5C': '#6e79ad',
  '5d': '#c2df8a',
  '5D': '#47067',
  '6a': '#630960',
  '6A': '#41a8cc',
  '6b': '#d3d423',
  '6B': '#68a26d',
  '6c': '#b9a27',
  '6C': '#45a82',
  '6d': '#46a82c',
  '6D': '#2f4f0',
  '7A': '#897a4b',
  '7B': '#85bd2e',
  '7C': '#19070e',
  '7D': '#5ae047',
  '8a': '#79b373',
  '8A': '#33e1a9',
  '8b': '#757586',
  '8B': '#1b28c8',
  '8c': '#e5fb60',
  '8C': '#a1769a',
  '8d': '#862cae',
  '8D': '#564964',
  '9a': '#3107eb',
  '9A': '#8a03a9',
  '9b': '#93699',
  '9B': '#81ddf7',
  '9c': '#e71657',
  '9C': '#88e84d',
  '9d': '#d753be',
  '9D': '#5432f7',
  '10A': '#718584',
  '10B': '#7b9052',
  '10C': '#e046b2',
  '10d': '#5a4921',
  '10D': '#3e9b96',
  '11a': '#761c57',
  '11A': '#681c37',
  '11b': '#b44f8',
  '11B': '#92609b',
  '11c': '#ef4e5d',
  '11C': '#d94a02',
  '11d': '#fb156a',
  '11D': '#f830f0',
  '12a': '#206100',
  '12A': '#bc94da',
  '12b': '#6f58e5',
  '12B': '#92d6c7',
  '12c': '#def603',
  '12C': '#d0e89a',
  '12d': '#100afc',
  '12D': '#7d0810',
  '13a': '#959e5d',
  '13A': '#c6d5d9',
  '13b': '#99847e',
  '13B': '#f87426',
  '13c': '#f65b66',
  '13C': '#8b4ac',
  '13d': '#3ae91d',
  '13D': '#df546e',
  '14a': '#54210d',
  '14A': '#7f0049',
  '14b': '#33acb9',
  '14B': '#a5e427',
  '14c': '#fd042f',
  '14C': '#ae43bb',
  '14d': '#88ba1f',
  '14D': '#7b688',
  '15a': '#4f1f1f',
  '15A': '#9c8c81',
  '15b': '#137fab',
  '15B': '#77a883',
  '15c': '#88c079',
  '15C': '#9d51a8',
  '15d': '#4e5a1c',
  '15D': '#467dcc',
  '16a': '#314ddc',
  '16A': '#c8b3fa',
  '16b': '#9b634c',
  '16B': '#6bd22c',
  '16c': '#244605',
  '16C': '#eacd26',
  '16d': '#fac871',
  '16D': '#2ece8a',
  '17A': '#8bfda4',
  '17B': '#169fb7',
  '17c': '#7e28d',
  '17C': '#b02282',
  '17d': '#d6e2c9',
  '17D': '#6484f7',
  '18a': '#8b4b51',
  '18A': '#cb489f',
  '18b': '#7f61bf',
  '18B': '#fa51a1',
  '18c': '#73e6cf',
  '18C': '#eef4e9',
  '18d': '#a5ab7d',
  '18D': '#5425c5',
  '19a': '#12d8fd',
  '19A': '#b983ad',
  '19b': '#cce796',
  '19B': '#d249f8',
  '19c': '#6e06cc',
  '19C': '#a284c1',
  '19d': '#c92297',
  '19D': '#7da4cf',
  '20a': '#4d99d9',
  '20A': '#521ea',
  '20b': '#bc7d2b',
  '20B': '#106cbf',
  '20c': '#de9026',
  '20C': '#9a703',
  '20d': '#48be4a',
  '20D': '#5c0a11',
  '21a': '#7cda3c',
  '21A': '#dfa48b',
  '21b': '#e7c3c3',
  '21B': '#d12e63',
  '21c': '#688aa4',
  '21C': '#e2614d',
  '21d': '#2054bd',
  '21D': '#5f23d5',
  '22a': '#da99c2',
  '22A': '#e25fc9',
  '22b': '#900610',
  '22B': '#e7db1e',
  '22c': '#777f43',
  '22C': '#d81d2d',
  '22d': '#42d91',
  '22D': '#2d61c5',
  '23a': '#6dab06',
  '23A': '#5a4393',
  '23b': '#c2cfdd',
  '23B': '#656337',
  '23c': '#96fc0d',
  '23C': '#b70017',
  '23d': '#1deca4',
  '23D': '#7274e7',
  '24a': '#163302',
  '24A': '#14a256',
  '24b': '#976dbe',
  '24B': '#8a4f35',
  '24c': '#eb77b7',
  '24C': '#a8f9be',
  '24d': '#657b43',
  '24D': '#4fd0d6',
  '25a': '#5ce8f8',
  '25A': '#bd88d4',
  '25b': '#185e01',
  '25B': '#23b4b8',
  '25c': '#836510',
  '25C': '#8cbcdb',
  '25d': '#772178',
  '25D': '#b511fd',
  '26a': '#44a5da',
  '26A': '#53b02a',
  '26b': '#8b4680',
  '26B': '#233d3',
  '26c': '#f35f8e',
  '26C': '#3113ab',
  '26d': '#c8f56f',
  '26D': '#ce9de5',
  '27a': '#eb4302',
  '27A': '#47b098',
  '27b': '#ca277a',
  '27B': '#53e7ef',
  '27c': '#608bf9',
  '27C': '#cbd5a3',
  '27d': '#aa800f',
  '27D': '#4ba7ee',
  '28a': '#dc7cb3',
  '28A': '#5778ed',
  '28b': '#8d91db',
  '28B': '#9e0ed',
  '28c': '#27917b',
  '28C': '#b948e2',
  '28d': '#4c8a6b',
  '28D': '#5a987f',
  '29a': '#729ed8',
  '29A': '#6fae00',
  '29b': '#dbf052',
  '29B': '#43a9b3',
  '29c': '#9d8eb1',
  '29C': '#d4fb27',
  '29d': '#5fd365',
  '29D': '#56958c',
  '30a': '#5bd174',
  '30A': '#3e9782',
  '30b': '#969449',
  '30B': '#18df0f',
  '30c': '#b9fdd3',
  '30C': '#856cd7',
  '30d': '#42b0dc',
  '30D': '#40a432',
  '31a': '#204c88',
  '31A': '#c905a4',
  '31b': '#2898c5',
  '31B': '#1ad33f',
  '31c': '#5968e2',
  '31C': '#459933',
  '31d': '#c7425a',
  '31D': '#575b17',
  '32a': '#6a035d',
  '32A': '#fba964',
  '32b': '#8a538f',
  '32B': '#9ccf37',
  '32c': '#bbcc30',
  '32C': '#e3f07e',
  '32d': '#d732a6',
  '32D': '#e8bbc8',
  '33a': '#4f1b10',
  '33A': '#cf4f24',
  '33b': '#2e355',
  '33B': '#ef49b1',
  '33c': '#ecc507',
  '33C': '#641508',
  '33d': '#affa5f',
  '33D': '#18c81',
  '34a': '#ef2cf5',
  '34A': '#5a278d',
  '34b': '#704603',
  '34B': '#ef0c06',
  '34c': '#a79711',
  '34C': '#96d971',
  '34d': '#9da75e',
  '34D': '#ffddba',
  '35a': '#5f43a',
  '35A': '#c0b587',
  '35b': '#969070',
  '35B': '#71ad2f',
  '35c': '#8d218c',
  '35C': '#84a450',
  '35d': '#48e70e',
  '35D': '#7468d',
  '36a': '#84ae27',
  '36A': '#fb19eb',
  '36b': '#92522d',
  '36B': '#377984',
  '36c': '#c7a6db',
  '36C': '#d936e3',
  '36d': '#1b32b1',
  '36D': '#f27b7',
  '37a': '#3afc1a',
  '37A': '#1d85e8',
  '37b': '#fe02ba',
  '37B': '#24d2b7',
  '37c': '#6dd92f',
  '37C': '#9307dd',
  '37d': '#6c6a3f',
  '37D': '#22881c',
  '38a': '#6f2f23',
  '38A': '#8401af',
  '38b': '#fd58bb',
  '38B': '#21e480',
  '38c': '#21145d',
  '38C': '#549ab8',
  '38d': '#5773c1',
  '38D': '#31037',
  '39a': '#2ebad4',
  '39A': '#e3486c',
  '39b': '#6276aa',
  '39B': '#14e461',
  '39c': '#2bf1e0',
  '39C': '#624410',
  '39d': '#f43738',
  '39D': '#497f57',
  '40a': '#f543dd',
  '40A': '#b918f3',
  '40b': '#81d5b9',
  '40B': '#b952c4',
  '40c': '#419c64',
  '40C': '#dd511f',
  '40d': '#126cad',
  '40D': '#e6edd5',
  '41a': '#4458ed',
  '41A': '#1a8e39',
  '41b': '#5b635b',
  '41B': '#1f4d7c',
  '41c': '#2b0b5a',
  '41C': '#4945a4',
  '41d': '#ee0e7e',
  '41D': '#ac08ef',
  '42a': '#abcef1',
  '42A': '#4fd178',
  '42b': '#80b5a6',
  '42B': '#a218d8',
  '42c': '#e9fb12',
  '42C': '#3fb170',
  '42d': '#24a211',
  '42D': '#11e68a',
  '43a': '#6bdd7a',
  '43A': '#46a2d4',
  '43b': '#f9bda',
  '43B': '#312802',
  '43c': '#d7f7b4',
  '43C': '#a1b135',
  '43d': '#bbe48a',
  '43D': '#10c64',
  '44a': '#5d572f',
  '44A': '#bc82b9',
  '44b': '#f1ad01',
  '44B': '#e21a96',
  '44c': '#ed6fc7',
  '44C': '#1e9476',
  '44d': '#3564f5',
  '44D': '#7763c2',
  '45a': '#90348d',
  '45A': '#9854c6',
  '45b': '#ba9f24',
  '45B': '#2a8b31',
  '45c': '#c1644d',
  '45C': '#87044c',
  '45d': '#3135c',
  '45D': '#f191c0',
  '46a': '#5dfc03',
  '46A': '#3a385c',
  '46b': '#dd1cee',
  '46B': '#a2ff67',
  '46c': '#c63336',
  '46C': '#200dc6',
  '46d': '#6d6aa4',
  '46D': '#137290',
  '47a': '#57adc1',
  '47A': '#3464f0',
  '47b': '#f23682',
  '47B': '#785df5',
  '47c': '#3e8f5',
  '47C': '#b992ec',
  '47d': '#ade6f',
  '47D': '#b435fb',
  '48a': '#5ab773',
  '48A': '#f1f369',
  '48b': '#94f455',
  '48B': '#ca4ff4',
  '48c': '#2fe780',
  '48C': '#aac7d7',
  '48d': '#1c4e03',
  '48D': '#cc6bd',
  '49a': '#d5ed44',
  '49A': '#7a3fa4',
  '49b': '#49420f',
  '49B': '#5b02f2',
  '49c': '#c6e2d8',
  '49C': '#e7d5fc',
  '49d': '#9ef180',
  '49D': '#d8fe52',
  '50a': '#3581de',
  '50A': '#853278',
  '50b': '#ea9a4d',
  '50B': '#92f899',
  '50c': '#68bb05',
  '50C': '#74b78e',
  '50d': '#db317e',
  '50D': '#8fca03',
  '51a': '#85cee',
  '51A': '#e14ae3',
  '51b': '#5f2a61',
  '51B': '#c1ca5',
  '51c': '#f79b3c',
  '51C': '#2dbc59',
  '51d': '#55d090',
  '51D': '#7de9a5',
  '52a': '#1e1a18',
  '52A': '#f86842',
  '52b': '#9e7d80',
  '52B': '#54e51e',
  '52c': '#4c392c',
  '52C': '#d38c26',
  '52d': '#c93e91',
  '52D': '#a160b0',
  '53a': '#520168',
  '53A': '#89fcd2',
  '53b': '#5a157',
  '53B': '#dc3fc1',
  '53c': '#13e679',
  '53C': '#67c164',
  '53d': '#498ead',
  '53D': '#20485f',
  '54a': '#c2e8f8',
  '54A': '#a3eb91',
  '54b': '#30ea4c',
  '54B': '#855f97',
  '54c': '#bd7fb7',
  '54C': '#70fb2',
  '54d': '#fe4ccb',
  '54D': '#d26d53',
  '55a': '#ab5796',
  '55A': '#f87678',
  '55b': '#cfa8fe',
  '55B': '#e92304',
  '55c': '#8af796',
  '55C': '#41e7bc',
  '55d': '#3029f9',
  '55D': '#6b94bb',
  '56a': '#46d647',
  '56A': '#8db724',
  '56b': '#101d71',
  '56B': '#65f43',
  '56c': '#e13799',
  '56C': '#df5d75',
  '56d': '#278686',
  '56D': '#bff27b',
  '57a': '#20715',
  '57A': '#c1b216',
  '57b': '#7b802a',
  '57B': '#db426d',
  '57c': '#99dde5',
  '57C': '#bd25e',
  '57d': '#52bb87',
  '57D': '#1bd828',
  '58a': '#d6bb48',
  '58A': '#c32f3d',
  '58b': '#f45e16',
  '58B': '#aa5f34',
  '58c': '#223cf2',
  '58C': '#12c89b',
  '58d': '#dc5a28',
  '58D': '#868674',
  '59a': '#797745',
  '59A': '#92383e',
  '59b': '#a54707',
  '59B': '#4a414e',
  '59c': '#53adc3',
  '59C': '#7c60b0',
  '59d': '#e82a62',
  '59D': '#442cf5',
  '60a': '#da3bfa',
  '60A': '#2e3635',
  '60b': '#af209c',
  '60B': '#36d27b',
  '60c': '#88d093',
  '60C': '#9472d3',
  '60d': '#91d84e',
  '60D': '#5f475a',
  '61a': '#8c9673',
  '61A': '#3d7584',
  '61b': '#562da1',
  '61B': '#244a78',
  '61c': '#65e893',
  '61C': '#f86ee0',
  '61d': '#814b23',
  '61D': '#73d1cb',
  '62a': '#1c850e',
  '62A': '#6ebd9a',
  '62b': '#6c5b0',
  '62B': '#5f1060',
  '62c': '#ab5f0d',
  '62C': '#94edd8',
  '62d': '#b201b8',
  '62D': '#a607d8',
  '63a': '#23f3ae',
  '63A': '#738841',
  '63b': '#c8f436',
  '63B': '#1a0161',
  '63c': '#f1cfa9',
  '63C': '#62e522',
  '63d': '#b3a959',
  '63D': '#5578b',
  '64a': '#eede6b',
  '64A': '#6cb3f4',
  '64b': '#92ab91',
  '64B': '#fe5251',
  '64c': '#d0b64',
  '64C': '#1a8961',
  '64d': '#92126a',
  '64D': '#e56863',
  '65a': '#475503',
  '65A': '#f9ed64',
  '65b': '#268f13',
  '65B': '#23570b',
  '65c': '#5fd848',
  '65C': '#ec0e72',
  '65d': '#57a0a1',
  '65D': '#82fa5b',
  '66a': '#437623',
  '66A': '#59753b',
  '66b': '#cdcc5c',
  '66B': '#672d2d',
  '66c': '#421b41',
  '66C': '#ae031a',
  '66d': '#81e676',
  '66D': '#6fd38c',
  '67a': '#453679',
  '67A': '#56ec30',
  '67b': '#e717cd',
  '67B': '#efd7f',
  '67c': '#8137a6',
  '67C': '#6e398b',
  '67d': '#4767fd',
  '67D': '#6ab3a4',
  '68a': '#2d2279',
  '68A': '#c7ba85',
  '68b': '#878592',
  '68B': '#6813e7',
  '68c': '#d947e1',
  '68C': '#60e975',
  '68d': '#18ee51',
  '68D': '#5faef3',
  '69a': '#228dbf',
  '69A': '#a4671b',
  '69b': '#7e3d87',
  '69B': '#2516a3',
  '69c': '#bc8b4',
  '69C': '#c40b35',
  '69d': '#39dd61',
  '69D': '#441603',
  '70a': '#1cd456',
  '70A': '#a1dd51',
  '70b': '#a92f13',
  '70B': '#e5544e',
  '70c': '#13a48a',
  '70C': '#fecbcf',
  '70d': '#a217c5',
  '70D': '#a7876',
  '71a': '#f2f44',
  '71A': '#c62b2e',
  '71b': '#7e1bba',
  '71B': '#851095',
  '71c': '#c18d03',
  '71C': '#528005',
  '71d': '#3e3a5b',
  '71D': '#b0ea8f',
  '72a': '#1a6b73',
  '72A': '#9f7585',
  '72b': '#d42225',
  '72B': '#f9ec38',
  '72c': '#e98a4',
  '72C': '#cd7dc5',
  '72d': '#ea4649',
  '72D': '#e4479e',
  '73a': '#3cd099',
  '73A': '#2e49ef',
  '73b': '#d715a8',
  '73B': '#1edeaf',
  '73c': '#aff15e',
  '73C': '#fad4c3',
  '73d': '#3b3084',
  '73D': '#b60a84',
  '74a': '#97f3f7',
  '74A': '#186a4c',
  '74b': '#943c07',
  '74B': '#cf2c67',
  '74c': '#4dcc9b',
  '74C': '#3a13af',
  '74d': '#babe58',
  '74D': '#f5af11',
  '75a': '#58d53',
  '75A': '#4255aa',
  '75b': '#f2e50a',
  '75B': '#80ded7',
  '75c': '#6e0c',
  '75C': '#323a25',
  '75d': '#67e10a',
  '75D': '#81bdb1',
  '76a': '#d3091c',
  '76A': '#7cd9e5',
  '76b': '#c52e2e',
  '76B': '#8f6eeb',
  '76c': '#4acc2d',
  '76C': '#4d5b7e',
  '76d': '#921298',
  '76D': '#e93d9f',
  '77a': '#4d0dd1',
  '77A': '#b8841e',
  '77b': '#8f3d88',
  '77B': '#d83139',
  '77c': '#5628d1',
  '77C': '#c80939',
  '77d': '#1f9134',
  '77D': '#44d756',
  '78a': '#765b8f',
  '78A': '#e0f259',
  '78b': '#f09247',
  '78B': '#d8be70',
  '78c': '#822000',
  '78C': '#9a270',
  '78d': '#29f437',
  '78D': '#f16d8e',
  '79a': '#c0bb2f',
  '79A': '#d61cc9',
  '79b': '#bf613e',
  '79B': '#605d51',
  '79c': '#832cc4',
  '79C': '#9d2266',
  '79d': '#881e3e',
  '79D': '#78adc',
  '80a': '#735ecc',
  '80A': '#25c46b',
  '80b': '#e59e0c',
  '80B': '#55dfbc',
  '80c': '#f462b9',
  '80C': '#474839',
  '80d': '#53f691',
  '80D': '#125c03',
  '81a': '#681869',
  '81A': '#4d725b',
  '81b': '#acb70e',
  '81B': '#52eb17',
  '81c': '#a01a8a',
  '81C': '#46db49',
  '81d': '#9c96b0',
  '81D': '#e0ae07',
  '82a': '#98a527',
  '82A': '#40341c',
  '82b': '#1b6f35',
  '82B': '#d4d362',
  '82c': '#64e00a',
  '82C': '#6043f',
  '82d': '#9a3f65',
  '82D': '#8526bd',
  '83a': '#9e80a7',
  '83A': '#624fca',
  '83b': '#e075d9',
  '83B': '#af9d9b',
  '83c': '#547935',
  '83C': '#204a49',
  '83d': '#c51d20',
  '83D': '#4a0f17',
  '84a': '#32de53',
  '84A': '#ad5e4c',
  '84b': '#3c9001',
  '84B': '#efcb60',
  '84c': '#344db',
  '84C': '#1ef67',
  '84d': '#a50da2',
  '84D': '#169225',
  '85a': '#cd5f4e',
  '85A': '#de58dd',
  '85b': '#a1319a',
  '85B': '#f6a02e',
  '85c': '#d794ac',
  '85C': '#98e28e',
  '85d': '#3a0640',
  '85D': '#b33f7',
  '86a': '#48121f',
  '86A': '#3d0c15',
  '86b': '#73a349',
  '86B': '#c0191a',
  '86c': '#515ccd',
  '86C': '#ded479',
  '86d': '#b26bf3',
  '86D': '#854343',
  '87a': '#f8dac5',
  '87A': '#fbfed9',
  '87b': '#c192f4',
  '87B': '#81d578',
  '87c': '#63f41b',
  '87C': '#fcb361',
  '87d': '#c8d4e1',
  '87D': '#8e4406',
  '88a': '#2cf364',
  '88A': '#52a69d',
  '88b': '#4afe1a',
  '88B': '#2d2216',
  '88c': '#f3f644',
  '88C': '#87d796',
  '88d': '#9488e1',
  '88D': '#2c8cbe',
  '89a': '#2132fd',
  '89A': '#51b4f2',
  '89b': '#84c60b',
  '89B': '#b2e264',
  '89c': '#5740b6',
  '89C': '#a6f31',
  '89d': '#61e1fe',
  '89D': '#e3769c',
  '90a': '#c22d01',
  '90A': '#10f947',
  '90b': '#a8d7ec',
  '90B': '#265d3',
  '90c': '#bc1254',
  '90C': '#dedbb3',
  '90d': '#28c7ae',
  '90D': '#30e293',
  '91a': '#45d3ff',
  '91A': '#640585',
  '91b': '#5ebc60',
  '91B': '#6928b4',
  '91c': '#b25c7c',
  '91C': '#7ba09a',
  '91d': '#866976',
  '91D': '#c4e96f',
  '92a': '#ade779',
  '92A': '#fc1c2e',
  '92b': '#4601f9',
  '92B': '#5eb667',
  '92c': '#c80dc',
  '92C': '#eeac54',
  '92d': '#1b1827',
  '92D': '#55dfc0',
  '93a': '#51aef6',
  '93A': '#18a272',
  '93b': '#b32299',
  '93B': '#beacc3',
  '93c': '#d22a4c',
  '93C': '#7b2861',
  '93d': '#526ebf',
  '93D': '#34225c',
  '94a': '#e0e067',
  '94A': '#bb0480',
  '94b': '#e8b512',
  '94B': '#1005a8',
  '94c': '#7dfe98',
  '94C': '#44b002',
  '94d': '#e2a8e6',
  '94D': '#32d97a',
  '95a': '#68c513',
  '95A': '#7bef6e',
  '95b': '#e29da7',
  '95B': '#697e7',
  '95c': '#1f6d49',
  '95C': '#e33d1f',
  '95d': '#df6c9',
  '95D': '#de55f7',
  '96a': '#9e5105',
  '96b': '#5530cd',
  '96c': '#247b7f',
  '96d': '#2fa1b2',
  '97a': '#ee8844',
  '97A': '#d097c7',
  '97b': '#4ff40',
  '97B': '#48659a',
  '97c': '#a31161',
  '97C': '#41b1db',
  '97d': '#96e58a',
  '97D': '#b50992',
  '98a': '#273dd4',
  '98A': '#41228b',
  '98b': '#cef747',
  '98B': '#5def37',
  '98c': '#c0f78b',
  '98C': '#d99a21',
  '98d': '#6605e0',
  '98D': '#e0c51b',
  '99a': '#9899c9',
  '99A': '#7325ea',
  '99b': '#5748db',
  '99B': '#8177a0',
  '99c': '#8faeea',
  '99C': '#6e4c84',
  '99d': '#1716db',
  '99D': '#25494',
  '100a': '#f05993',
  '100A': '#e53f3c',
  '100b': '#d370c4',
  '100B': '#13d92a',
  '100c': '#9e4060',
  '100C': '#1360e1',
  '100d': '#82b89b',
  '100D': '#7c3f2b',
  '101a': '#88483e',
  '101A': '#ccc0c6',
  '101b': '#443e0f',
  '101B': '#fa2c0f',
  '101c': '#2cc0e0',
  '101C': '#dd9993',
  '101d': '#5f3564',
  '101D': '#89b0f7',
  '102a': '#571994',
  '102A': '#727ea',
  '102b': '#810ad7',
  '102B': '#bf3cfd',
  '102c': '#33e14f',
  '102C': '#dcad25',
  '102d': '#76c986',
  '102D': '#5a1723',
  '103a': '#52e763',
  '103A': '#87f33c',
  '103b': '#325fcd',
  '103B': '#d4315d',
  '103c': '#55985',
  '103C': '#27163f',
  '103d': '#436c4',
  '103D': '#dbd2dd',
  '104a': '#ba3a9',
  '104A': '#194c06',
  '104b': '#292168',
  '104B': '#e3054e',
  '104c': '#dec7e1',
  '104C': '#4208c0',
  '104d': '#557d8f',
  '104D': '#a47594',
  '105a': '#1672a8',
  '105A': '#d27317',
  '105b': '#a57766',
  '105B': '#97273d',
  '105c': '#4dc640',
  '105C': '#24a18d',
  '105d': '#ece8b8',
  '105D': '#4975e2',
  '106a': '#a74e8d',
  '106A': '#9cf4ef',
  '106b': '#106a4e',
  '106B': '#9f8045',
  '106c': '#965a3b',
  '106C': '#10f11c',
  '106d': '#456605',
  '106D': '#47aeab',
  '107a': '#ab1117',
  '107A': '#7c2116',
  '107b': '#1b6b7',
  '107B': '#bc2c42',
  '107c': '#43371f',
  '107C': '#d4411',
  '107d': '#3ee324',
  '107D': '#c59101',
  '108a': '#c579b0',
  '108A': '#f41401',
  '108b': '#e1eb12',
  '108B': '#10568',
  '108c': '#245813',
  '108C': '#a8ce40',
  '108d': '#bf8a0f',
  '108D': '#37d048',
  '109a': '#6d67c9',
  '109A': '#75db95',
  '109b': '#a9ef62',
  '109B': '#6a3837',
  '109c': '#8a16d0',
  '109C': '#17eb35',
  '109d': '#409d2b',
  '109D': '#d1034c',
  '110a': '#afd3eb',
  '110A': '#b813d4',
  '110b': '#7752ce',
  '110B': '#c2b7ed',
  '110c': '#49322f',
  '110C': '#b17349',
  '110d': '#5e19ca',
  '110D': '#27d0b5',
};

// The new object
const additionalColorPallet = {};

// Generate random colors for each entry not in originalColorPallet
for (let i = 1; i <= 110; i++) {
  const baseKey = i.toString();

  // Add the base entry if it doesn't already exist
  if (!originalColorPallet[baseKey]) {
    additionalColorPallet[baseKey] = `#${Math.floor(
      Math.random() * 16777215
    ).toString(16)}`;
  }

  // Add the four sub-entries if they don't already exist
  for (let j = 65; j <= 115; j++) {
    const subKey = `${baseKey}${String.fromCharCode(j)}`;
    if (!originalColorPallet[subKey]) {
      additionalColorPallet[subKey] = `#${Math.floor(
        Math.random() * 16777215
      ).toString(16)}`;
    }

    const subKeyUpper = `${baseKey}${String.fromCharCode(j).toUpperCase()}`;
    if (!originalColorPallet[subKeyUpper]) {
      additionalColorPallet[subKeyUpper] = `#${Math.floor(
        Math.random() * 16777215
      ).toString(16)}`;
    }
  }
}

// Add the '-others' entry if it doesn't already exist
if (!originalColorPallet['-others']) {
  additionalColorPallet['-others'] = '#cececa';
}

// Merge the two objects using Object.assign()
export const colorPallet = Object.assign(
  {},
  originalColorPallet,
  additionalColorPallet
);
export const rs32Color = {
  'clustered_del_>10Mb': 'deeppink',
  'non-clustered_del_>10Mb': 'deeppink',
  'clustered_del_1Mb-10Mb': 'hotpink',
  'non-clustered_del_1Mb-10Mb': 'hotpink',
  'clustered_del_10-100Kb': 'lightpink',
  'non-clustered_del_10-100Kb': 'lightpink',
  'clustered_del_100Kb-1Mb': 'palevioletred',
  'non-clustered_del_100Kb-1Mb': 'palevioletred',
  'clustered_del_1-10Kb': 'lavenderblush',
  'non-clustered_del_1-10Kb': 'lavenderblush',
  'clustered_tds_>10Mb': 'saddlebrown',
  'non-clustered_tds_>10Mb': 'saddlebrown',
  'clustered_tds_1Mb-10Mb': 'sienna',
  'non-clustered_tds_1Mb-10Mb': 'sienna',
  'clustered_tds_10-100Kb': 'sandybrown',
  'non-clustered_tds_10-100Kb': 'sandybrown',
  'clustered_tds_100Kb-1Mb': 'peru',
  'non-clustered_tds_100Kb-1Mb': 'peru',
  'clustered_tds_1-10Kb': 'linen',
  'non-clustered_tds_1-10Kb': 'linen',
  'clustered_inv_>10Mb': 'rebeccapurple',
  'non-clustered_inv_>10Mb': 'rebeccapurple',
  'clustered_inv_1Mb-10Mb': 'blueviolet',
  'non-clustered_inv_1Mb-10Mb': 'blueviolet',
  'clustered_inv_10-100Kb': 'plum',
  'non-clustered_inv_10-100Kb': 'plum',
  'clustered_inv_100Kb-1Mb': 'mediumorchid',
  'non-clustered_inv_100Kb-1Mb': 'mediumorchid',
  'clustered_inv_1-10Kb': 'thistle',
  'non-clustered_inv_1-10Kb': 'thistle',
  clustered_trans: 'gray',
  'non-clustered_trans': 'gray',
  del: '#800001',
  tds: '#FF8C00',
  inv: '#6A5ACD',
  tra: '#696969',
};

export const sbsColor = {
  'C>A': '#03BCEE',
  'C>G': 'black',
  'C>T': '#E32926',
  'T>A': '#CAC9C9',
  'T>C': '#A1CE63',
  'T>G': '#EBC6C4',
};

export const id83Color = {
  '1:Del:C': { shape: '#FBBD6F', text: 'black' },
  '1:Del:T': { shape: '#FE8002', text: 'white' },
  '1:Ins:C': { shape: '#AEDD8A', text: 'black' },
  '1:Ins:T': { shape: '#35A12E', text: 'white' },
  '2:Del:R': { shape: '#FCC9B4', text: 'black' },
  '3:Del:R': { shape: '#FB8969', text: 'black' },
  '4:Del:R': { shape: '#F04432', text: 'black' },
  '5:Del:R': { shape: '#BB1A1A', text: 'white' },
  '2:Ins:R': { shape: '#CFDFF0', text: 'black' },
  '3:Ins:R': { shape: '#93C3DE', text: 'black' },
  '4:Ins:R': { shape: '#4B97C7', text: 'black' },
  '5:Ins:R': { shape: '#1863AA', text: 'white' },
  '2:Del:M': { shape: '#E1E1EE', text: 'blacl' },
  '3:Del:M': { shape: '#B5B5D6', text: 'black' },
  '4:Del:M': { shape: '#8482BC', text: 'black' },
  '5:Del:M': { shape: '#62409A', text: 'white' },
};

export const dbs78Color = {
  AC: '#09BCED',
  AT: '#0266CA',
  CC: '#9FCE62',
  CG: '#006501',
  CT: '#FF9898',
  GC: '#E22925',
  TA: '#FEB065',
  TC: '#FD8000',
  TG: '#CB98FD',
  TT: '#4C0299',
};
